import "./SolidProducts.module.css";
import Header from "@/reusable_sections/Header";
import ProductosSLidos from "./sections/ProductosSLidos";
import Footer from "@/reusable_sections/Footer";
export default function SolidProductsPage() {
  return <div>
      <Header />
      <ProductosSLidos />
      <Footer />
    </div>;
}